import React, { ReactElement } from "react";
import styles from "./partnerships.module.scss";
import { LazyLoadedMarquee } from "@kunduz/utility-marquee";
import { CommonComponentProps } from "@kunduz/feature-landing-pages";
import classNames from "classnames";

export const Partnerships = (props: PartnershipsProps): ReactElement => {
  const {
    options: { sizeDesktop, sizeMobile, sizeTablet },
  } = props;

  const ImageContent = () => {
    return props.imageUrls.map((img, i) => (
      <img
        src={img.image}
        key={i}
        loading="lazy"
        alt=""
        className={styles.logo}
      />
    ));
  };

  return (
    <section
      className={classNames(
        styles.container,
        styles[`${sizeMobile}Mobile`],
        styles[`${sizeTablet}Tablet`],
        styles[`${sizeDesktop}Desktop`],
      )}
      style={{ backgroundColor: props.backgroundColor }}
    >
      <div className={styles.contentContainer}>
        {props.title && <p className={styles.title}>{props.title}</p>}
        {!props.slider && (
          <div className={styles.regularImageWrapper}>
            <ImageContent />
          </div>
        )}
        {props.slider && (
          <div className={styles.sliderContainer}>
            <LazyLoadedMarquee
              autoFill
              pauseOnHover={props.pauseOnHover}
              gradient={props.isSliding}
              gradientColor={props.isTransparent ? props.backgroundColor : null}
              className={styles.marquee}
            >
              <div className={styles.slidingImageWrapper}>
                <ImageContent />
              </div>
            </LazyLoadedMarquee>
          </div>
        )}
      </div>
    </section>
  );
};

export interface PartnershipsProps extends CommonComponentProps {
  title: string;
  imageUrls: [{ image: string }];
  slider: boolean;
  backgroundColor: string;
  isSliding: boolean;
  isTransparent: boolean;
  pauseOnHover: boolean;
}
